// extracted by mini-css-extract-plugin
export default {"calendarWrapper":"Calendar_calendarWrapper__LZeTs"};